import type React from 'react';
import type { ReactElement, ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

/**
 * Renders a slot for a specific component type.
 * @param SlotComponent - The component type to render.
 * @param components - The components to search through.
 * @param props - Props to pass to the rendered component.
 * @returns The rendered component or null if not found.
 */
export function renderSlot<T extends React.ElementType>(
  SlotComponent: T,
  components: ReactNode,
  props?: { [key: string]: unknown },
): ReactElement | null {
  const match = Children.toArray(components).find(
    (component): component is ReactElement => {
      if (!isValidElement(component)) {
        return false;
      }

      if (component.type === SlotComponent) {
        return true;
      }

      return false;
    },
  );

  return match ? cloneElement(match, props, match.props.children) : null;
}
